export default __webpack_public_path__ + "static/media/box.f1e20a26.png";